import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Injectable, Input, ViewChild } from '@angular/core';
import { CommonServices } from '@asamco/base';
import { JsonEditorComponent, JsonEditorOptions, NgJsonEditorModule } from 'ang-jsoneditor';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';

@Component({
	selector: 'json-editor-modal',
	templateUrl: 'json-editor-modal.component.html',
	styleUrls: ['json-editor-modal.component.scss'],
	standalone: true,
	imports: [NgIf, NgJsonEditorModule]
})
@Injectable()
export class JsonEditorModalComponent {
	/**
	 * json edited event observable
	 */
	jsonEdited$: Subject<string>;
	/**
	 * JSON editor options
	 */
	jsonEditorOptions: JsonEditorOptions;
	/**
	 * JSON object being edited
	 */
	jsonObject;
	/**
	 * whether dialog is being shown
	 */
	showDialog = false;
	/**
	 * disables transparent black backdrop
	 */
	@Input()
	noBackdrop = false;

	@ViewChild(JsonEditorComponent)
	jsonEditorComponent: JsonEditorComponent;

	/**
	 * Constructor
	 */
	constructor(private cs: CommonServices, @Inject(L10N_LOCALE) public locale: L10nLocale, private cdRef: ChangeDetectorRef) {
		this.jsonEditorOptions = new JsonEditorOptions();
		this.jsonEditorOptions.modes = ['code', 'tree'];
	}

	/**
	 * Shows the settings editor modal
	 */
	showAndAwait(jsonObject) {
		this.jsonEdited$ = new Subject<any>();

		this.jsonObject = jsonObject;

		this.showDialog = true;

		this.cdRef.detectChanges();
		const jsed: HTMLElement = document.querySelector('json-editor');
		(<HTMLElement>jsed.firstElementChild).style.height = '60vh';

		return this.jsonEdited$;
	}

	/**
	 * Cancel button clicked.
	 */
	onCancelClick(): void {
		this.showDialog = false;
	}

	/**
	 * OK button clicked
	 */
	onOkClick(): void {
		try {
			this.jsonObject = this.jsonEditorComponent.get();

			JSON.stringify(this.jsonObject);

			this.jsonEdited$.next(this.jsonObject);
			this.jsonEdited$.complete();

			this.showDialog = false;
		} catch {
			swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Failed to parse JSON.',
			});
		}
	}
}
